import { CacheUtils } from '../utils/cacheUtils';

export const API_CACHE_EXPIRES = 60 * 60 * 12; // 12 часов
export const GET_SEO_URLS_API_CACHE_KEY = 'getSeoUriApi';
export const GET_SEO_DATA_API_CACHE_KEY = 'getSeoDataApi';

export const ApiCache = new CacheUtils(API_CACHE_EXPIRES);
